export default __webpack_public_path__ + "static/media/adult.b2309156.svg";